import * as service from './service'
export default {
  namespace: 'shansongStudyStudyTask',
  state: {
    listData: []
  },
  effects: {
    * getList ({ payload }, { call, put }) {
      const res = yield call(service.getList, payload)
      yield put({
        type: 'save',
        payload: {
          listData: res.data.data
        }
      })
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
